import { Menu, useCaptionOptions } from '@vidstack/react';
import { CheckIcon, ClosedCaptionsIcon } from '@vidstack/react/icons';
import { SubmenuButton } from "@/components/player/layouts/shared/menus/submenu-button";
import { usePlayerLayoutContext } from "@/components/player/layouts/PlayerLayoutContext";
import React from "react";
import { BraivClosedCaptionsIcon, BraivKaraokeCaptionsIcon, BraivModernCaptionsIcon } from "@/components/player/layouts/shared/playerIcons";
const captionOptions = [{
  value: 'closed',
  label: 'Closed captions',
  hint: 'Closed',
  Icon: BraivClosedCaptionsIcon
}, {
  value: 'karaoke',
  label: 'Karaoke captions',
  hint: 'Karaoke',
  Icon: BraivKaraokeCaptionsIcon
}, {
  value: 'modern',
  label: 'Modern captions',
  hint: 'Modern',
  Icon: BraivModernCaptionsIcon
}];
function getCaptionOption(value: string) {
  return captionOptions.find(option => option.value === value) || captionOptions[0];
}
export function CaptionsStyleSubmenu() {
  const captions = useCaptionOptions();
  const {
    captionStyle,
    setCaptionStyle
  } = usePlayerLayoutContext();
  const handleStyleChange = (value: any) => {
    setCaptionStyle(value);
  };
  const currentOption = getCaptionOption(captionStyle);

  // There is always at least one entry in captions which is to turn off captions
  // If the captions list is empty, we don't show the caption style menu
  if (captions.length <= 1) return null;
  return <Menu.Root className="vds-menu" data-sentry-element="unknown" data-sentry-component="CaptionsStyleSubmenu" data-sentry-source-file="captions-style-menu.tsx">
            <SubmenuButton label="Caption Style" hint={currentOption.hint} disabled={false} icon={ClosedCaptionsIcon} data-sentry-element="SubmenuButton" data-sentry-source-file="captions-style-menu.tsx" />
            <Menu.Content className="vds-menu-items" data-sentry-element="unknown" data-sentry-source-file="captions-style-menu.tsx">
                <Menu.RadioGroup className="vds-radio-group" value={captionStyle} data-sentry-element="unknown" data-sentry-source-file="captions-style-menu.tsx">
                    {captionOptions.map(({
          value,
          label,
          hint,
          Icon
        }) => <Menu.Radio className="vds-radio" key={value} value={value} onSelect={() => handleStyleChange(value)}>
                            <CheckIcon className="vds-icon" />
                            <Icon className={'vds-menu'} />
                            <span className="vds-radio-label ps-2">{label}</span>
                        </Menu.Radio>)}
                </Menu.RadioGroup>
            </Menu.Content>
        </Menu.Root>;
}